module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-37.fb3b6f90.jpg";